import { FC } from "react";
import { Modal } from "../../../components/Modal";
import { Button } from "../../../components/Button";
import "./style.css";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: React.ReactElement | React.ReactElement[];
}

export const ProdConfirmationModal: FC<Props> = ({
  isOpen,
  onConfirm,
  onClose,
  children,
}) => {
  return (
    <Modal isOpen={isOpen}>
      <div className="prod-confirmation-modal-content">
        {children}
        <Button
          className="prod-confirmation-modal-content-button-confirm"
          onClick={onConfirm}
        >
          Yes! Update
        </Button>
        <Button
          version="secondary"
          className="prod-confirmation-modal-content-button-reject"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
